module.exports = __webpack_public_path__ + "media/svg/experiences-80f3030c.svg";